let itemsAddedToCart = false; 

async function addProductToCart(itemsToAdd) {
  try {
    const batchAddToCartUrl = '/cart/add.js';

    const response = await fetch(batchAddToCartUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ items: itemsToAdd }),
    });

    if (!response.ok) {
      throw new Error('Failed to add items to cart');
    }

    const cartResponse = await fetch(`/cart?view=cart-items`);
    const responseText = await cartResponse.text();
    const html = new DOMParser().parseFromString(responseText, 'text/html');
    const items = html.querySelector('tbody');
  
    const container = document.querySelector('tbody');
    container.innerHTML = items.innerHTML

    const cartData = await response.json();
    console.log('Items added to cart:', cartData);

  } catch (error) {
    console.error('Error adding items to cart:', error);
  }
}

async function UpdateAddOnQty(data) {
  try {
    console.log(data)
    const url = `${window.Shopify.routes.root}cart/update.js`;

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
  
    if (response.ok) {
      const responseData = await response.json();
    } else {
      console.error('Error updating the cart');
    }

  } catch (error) {
    console.error('Error adding items to cart:', error);
  }
}

async function updateItemQuantity(){
  try {
    const cartResponse = await fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    });

    if (!cartResponse.ok) {
      throw new Error('Failed to fetch cart data');
    }

    const cart = await cartResponse.json();

    const cartItems = cart.items;

    const customizableElements = document.querySelectorAll('.hidden-customizable-item');
    const customizableHandles = Array.from(customizableElements).map(element => element.getAttribute('data-handle'));

    const accessoriesElements = document.querySelectorAll('.hidden-accessories-item');
    const accessoriesHandles = Array.from(accessoriesElements).map(element => element.getAttribute('data-handle'));


    itemsAddedToCart = cartItems.some(item => accessoriesHandles.includes(item.handle));
    const parentItem = cartItems.find(item => customizableHandles.includes(item.handle));
  
    const response = await fetch(`https://rebuyengine.com/api/v1/custom/id/114427?cart[items][0][product_id]=${parentItem.product_id}&cart[items][0][variant_id]=${parentItem.id}&cart[items][0][quantity]=1&key=6acd12eea488cb323b9b8da4f8d923108fa54cc9&format=pretty`);
    const parsedResponse = await response.json();
    let products = parsedResponse.data;

    if(products.length == 0){
      const response = await fetch(`https://rebuyengine.com/api/v1/custom/id/115437?cart[items][0][product_id]=${parentItem.product_id}&cart[items][0][variant_id]=${parentItem.id}&cart[items][0][quantity]=1&key=6acd12eea488cb323b9b8da4f8d923108fa54cc9&format=pretty`);
      const parsedResponse = await response.json();
      products = parsedResponse.data;
    }

    const itemsToAdd = [];

    products.forEach((product) => {
      const item = {
        id: product.variants[0].id, 
        quantity: parentItem.quantity, 
      };
      itemsToAdd.push(item);
    });

    if(!itemsAddedToCart && itemsToAdd.length > 0){
      await addProductToCart(itemsToAdd)
    }

    const cartResponseNew = await fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    });

    if (!cartResponse.ok) {
      throw new Error('Failed to fetch cart data');
    }

    const cartNew = await cartResponseNew.json();

    const cartItemsNew = cartNew.items;

    const accessories = cartItemsNew.filter(item => accessoriesHandles.includes(item.handle));

    let accessoriesIds = accessories.map(item => { return item.id })
    
    const mainCart = document.querySelector('cart-items'); 

    console.log(parentItem.id)
    mainCart.addEventListener('click', (event) => {
      const quantityInput = event.target.closest('quantity-input');

      console.log(event.target.closest('.cart-item').getAttribute('data-cart-item-key').includes(`${ parentItem.id }`))
      if (!quantityInput) return;
      if (!event.target.closest('.cart-item').getAttribute('data-cart-item-key').includes(`${ parentItem.id }`)) return;

      const minusButton = quantityInput.querySelector('button[name="minus"]');
      const plusButton = quantityInput.querySelector('button[name="plus"]');
      const inputField = quantityInput.querySelector('.quantity__input');
    
      if (event.target === minusButton) {
        const currentValue = Number(inputField.value);
        if (currentValue > 0) {
            const updates = {};
            accessoriesIds.forEach((variantId) => {
              updates[variantId] = currentValue;
            });
            
            const data = {
              updates: updates
            };
            
            UpdateAddOnQty(data)
        }
      } else if (event.target === plusButton) {
        const currentValue = Number(inputField.value);
          const updates = {};
          accessoriesIds.forEach((variantId) => {
            updates[variantId] = currentValue;
          });
          
          const data = {
            updates: updates
          };
          
          UpdateAddOnQty(data)
      }

      inputField.addEventListener('change', (event) => {
        if (event.target.matches('.quantity__input')) {
          const currentValue = Number(inputField.value);
          const updates = {};
          accessoriesIds.forEach((variantId) => {
            updates[variantId] = currentValue;
          });
          
          const data = {
            updates: updates
          };
          
          UpdateAddOnQty(data)
        }
      });
    });
    
  } catch (error) {
    console.error('Error:', error);
  }
}

document.addEventListener('DOMContentLoaded', function () {
  updateItemQuantity();
})


